<style src="@/assets/styles/components/modules/hosted-pages/cartFixed.styl" lang="stylus" scoped></style>
<template>
  <div>
    <div class="cb-breadcrumb" :class="[{'cb-breadcrumb--left' : canEditOrder() && navIcon == 'left', 'cb-breadcrumb--right' : canEditOrder() && navIcon == 'right'}]" v-if="cart_items_loaded && cart_items" @click="canEditOrder() && navigate()" v-cb-link="canEditOrder() && 'shadow'"
        :role="canEditOrder() && 'navigation'" data-cb-id="cart_summary">
        <div class="cb-breadcrumb__wrap">
          <div class="cb-line-item" v-for="(item, index) in consolidated_items" v-bind:key="index">
            <div class="cb-line-item__total" v-if="item.type != 'discount'">
                <span class="bounce">
                {{ amount_due | cbCurrency(currency_code) }}
                </span>
            </div>
            <div class="cb-line-item__name" :class="{'cb-line-item__name--muted': index > 0}" v-if="item.type != 'tax'">
                <span v-if="item.type != 'discount' && item.type != 'tax'">
                {{item.title(st,t)}} <span v-if="item.quantity > 1"> &times; {{item.quantity}}</span>
                </span>
                <span v-if="item.type == 'discount'">
                {{item.amount | cbCurrency(currency_code)}} {{getDiscountTxt()}}
                </span>
                <span v-if="index == 0 && consolidated_tax && (is_tax_inclusive || is_tax_exclusive)" class="cb-line-item__name--muted">
                  ({{cmt('incl_tax.txt')}})
                </span>
            </div>
        </div>
        </div>
        <div class="cb-breadcrumb__footer" :style="themeColor" v-if="trialInformation">
          {{trialInformation}}
        </div>
    </div>
    <div class="cb-breadcrumb" v-else>
        <div class="cb-placeholder__container cb-placeholder__tight">
            <cb-placeholder :custom-class="'sm rect-xl'" class="cb-placeholder__left"></cb-placeholder>
            <cb-placeholder :custom-class="'sm rect-sm'" class="cb-placeholder__right"></cb-placeholder>
        </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Vue from "vue"
import {
  mapGetters
} from "vuex"
import CartHelper from "@/utils/cart-helper"
import Placeholder from "@/components/collections/elements/Placeholder"
export default {
  props: ['editOrder', 'navIcon'],
  computed: {
    ...mapGetters([
      'cart_items',
      'cart_items_loaded',
      'consolidated_items',
      'currency_code',
      'amount_due',
      'consolidated_tax',
      'is_tax_inclusive',
      'is_tax_exclusive',
      'hosted_page_type',
    ]),
    trialInformation() {
      return (this.hosted_page_type == "checkout" && this.$store.getters.hasTrialPeriod) ? this.t("cart.trial.info", this.$store.getters.plan_placeholder) : null;
    }
  },
  components: {
    'cb-placeholder': Placeholder,
  },
  methods: {
    canEditOrder() {
      // quantity can be edited
      // addons can be remove
      // cart items more than 1
      // coupon can be applied
      // discount present
      return this.cart_items.some(item => CartHelper.canShowQuantity(item, this.$store.getters) || CartHelper.canRemove(item, this.$store.getters))
       || this.cart_items.length > 1
       || this.consolidated_items.length > 1
       || this.$store.getters.coupon_enabled;
    },
    getDiscountTxt() {
      return this.t('discounts_applied.label') || this.st('cart.discounts.applied')
    },
    navigate() {
      var section = this.editOrder ? "edit_order" : "cart";
      var mode = this.editOrder ? "edit" : "";
      if (!this.canEditOrder()) {
        return false;
      }
      this.$router.customPush({
        name: section,
        query: {
          mode: mode
        }
      });
    },
  }

}
</script>


// WEBPACK FOOTER //
// CartItemsComponent.vue?0b5fd467